import {createBasicReducer} from '../../utils/redux'
import {basicActions} from './actions'
import {initialState} from './constants'
import {AuthState} from './types'

export const reducer = createBasicReducer<AuthState>(initialState, basicActions)
